module.exports = __webpack_public_path__ + "static/media/logo_min_uno_azul.cbc10fc1.svg";